import React, { useEffect, useState } from "react"
import PageMetaTags from "components/PageMetaTags"
import { Container, Row, Col } from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { connect } from "react-redux"
import { getBusinessUnits, getMetaTags } from "store/actions"
import TagsList from "./tagsList"
// import { Tab, Tabs } from "@mui/material"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { URL_PATHS } from "constants/index"
import { SaveButton } from "components/Buttons"
import { userIsCorporate, userIsGodMode } from "utils"

const Tags = ({
  businessUnits,
  getBusinessUnits,
  getMetaTags,
  metaTags,
  history,
}) => {
  useEffect(() => {
    if (userIsCorporate() || userIsGodMode()) {
      getBusinessUnits()
    }
  }, [])

  const [tabValue, setTabValue] = useState("noBU")

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue)
  }

  useEffect(() => {
    if (tabValue === "noBU") {
      getMetaTags({ hide_for_business_unit: 1 })
    } else {
      getMetaTags({ business_unit_id: tabValue })
    }
  }, [tabValue])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Tag Management" />
        <Container fluid>
          <BreadcrumbTitle
            title="Tag Management"
            breadcrumbItems={[
              { title: "Dashboard" },
              { title: "Tag Management" },
            ]}
          />
          <Row>
            <p>
              Create tags to grant users' access to experiences. Assigning tags
              to experiences during setup will allow you to send notifications
              to users in the experience. Add an @ before the tag to create user
              groups and assign user access to experiences (@ makes the tag
              invisible to users and is for admin use).
            </p>
          </Row>
          <Row className="d-flex justify-content-end mb-2">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Add Tag"
                onClick={() => history?.push(URL_PATHS.CREATE_TAG)}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Tabs
                value={tabValue}
                onChange={handleChangeTab}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                textColor="inherit"
                sx={{
                  bgcolor: "background.paper",
                  borderBottom: 3,
                  borderColor: "#1976d2",
                }}
              >
                <Tab
                  label="Tags"
                  value={"noBU"}
                  sx={[
                    {
                      backgroundColor: tabValue === "noBU" ? "#1976d2" : "",
                      color: tabValue === "noBU" ? "white" : "black",
                      border: 1,
                      borderColor: "divider",
                      textTransform: "none",
                    },
                  ]}
                />
                {businessUnits &&
                  businessUnits.map(businessUnit => (
                    <Tab
                      key={businessUnit.id}
                      label={businessUnit.name}
                      value={businessUnit.id}
                      sx={[
                        {
                          backgroundColor:
                            tabValue === businessUnit.id ? "#1976d2" : "",
                          color:
                            tabValue === businessUnit.id ? "white" : "black",
                          border: 1,
                          borderColor: "divider",
                          textTransform: "none",
                        },
                      ]}
                    />
                  ))}
              </Tabs>
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <TagsList businessUnit={tabValue} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  businessUnits: state.businessUnits.businessUnits,
  metaTags: state.Tags.metaTags,
})

const mapDispatchToProps = dispatch => ({
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Tags)
